import { render, staticRenderFns } from "./VCardIcon.vue?vue&type=template&id=56690bf7&functional=true"
import script from "./VCardIcon.vue?vue&type=script&lang=js"
export * from "./VCardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports